import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Register from "../register/Register";
import Trending from "../trending/Trending";
import PremiumFranchise from "../premiumfrachise/PremiumFranchise";
import Bussiness from "../bussiness/Bussiness";
import Internationaloprtunites from "../Internationaloprtunites/Internationaloprtunites";
import TrendingVideo from "../trending/TrendingVideo";
import CompanyFeature from "../companyfeature/CompanyFeature";
import Newsblog from "../blogs/Newsblog";
import Hometestimonials from "../testimonials/Hometestimonials";
import AboutFranchisebx from "../about/AboutFranchisebx";
import Bussinesssection from "../bussiness/Bussinesssection";
import CarouselSlider from "../../common/carousel/Carousel";
import Api_Instance from "../../api/Api_Instance";
import { BASE_URL, CATEGORY, DashboardsEndpoints, endpoints } from "../../api/endpoints";
import { INVESTMENT_RANGE, LOAN_RANGE, STATE_DATA } from "../../utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import { setBanner_id, setCategoryid, setFilter, setLoader } from "../../redux/slice/Slice";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Upcomingevents from "../upcomingevents/Upcomingevents";
import Startup from "../startup/Stratup";
import Featured from "../../components/feature/Featured";
import "react-multi-carousel/lib/styles.css";
import { debounce } from "lodash";
import Addbanner from "../../components/addbanner/Addbanner";


function Dashboard() {
  const api = Api_Instance.unAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()
  const advertisementData = useSelector((state) => state?.auth?.advertisement_data)
  const [filterdata, setFilterdata] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formValues, setformValues] = useState({
    state: "",
    category: "",
    subcategory: "",
    price: "",
  });
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  }
  const [sectionData, setSectiondata] = useState({
    trending: [],
    premium: [],
    international: [],
    upcoming: [],
    featured: [],
    bussiness: [],
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const debouncedErrorToast = debounce(() => {
    toast.error("No data found");
  }, 500);
  const getFilterata = async (e) => {
    e.preventDefault();
    const allFieldsEmpty = Object.values(formValues).every((item) => item.trim() === "" || item.trim() === undefined);
    if (allFieldsEmpty) {
      debouncedErrorToast();
      return;
    }
    if (allFieldsEmpty) {
      debouncedErrorToast();
      return;
    }

    try {
      const res = await api("GET", endpoints.BUSSINESS_API, null, formValues);
      setFilterdata(res?.data?.data);
      dispatch(setFilter(res?.data?.data));
      dispatch(setCategoryid(formValues));

      if (res.status === 200 && res?.data?.status) {
        navigate("/products/best-bussiness");
      } else {
        toast.error(res?.data?.errors);
      }
    } catch (error) {
      toast.error("An error occurred while fetching data");
    }
  };

  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      dispatch(setBanner_id(res?.data?.data?.slice(0,1)))
      setCategoryData(res?.data?.data);

    } catch (error) { }
  };



  useEffect(() => {
    cateGoryApi();
    dispatch(setLoader(true))
  }, []);
  useEffect(() => {
  }, [formValues.category]);
  const GetTestimonials = async () => {
    try {
      setIsLoading(true);
      const res = await api("GET", DashboardsEndpoints?.GET_FRANCHISE_API);
      const data = res?.data?.data;
      const sectionData = {
        trending: [],
        premium: [],
        international: [],
        upcoming: [],
        featured: [],
        bussiness: [],
      };
     
      data?.forEach((item) => {
        item.status && item?.section?.map((data) => {
          switch (data) {
            case "trending franchises today":
              sectionData.trending.push(item);
              break;
            case "premium franchise opportunities":
              sectionData.premium.push(item);
              break;
            case "top international opportunities":
              sectionData.international.push(item);
              break;
            case "top franchise opportunities":
              // sectionData.featured.push(item);
              break;
            case "featured franchise companies":
              sectionData.featured.push(item);
              break;
            default:
              break;
          }


        })
      });

      setSectiondata(sectionData);
      if (res?.data?.data) {
        dispatch(setLoader(false))
      }
    } catch (error) {
      console.log(error);

    } finally {
      setIsLoading(false);

    }
  };

  useEffect(() => {
    GetTestimonials();
  }, []);


  return (
    <>
      <Addbanner />
      <PremiumFranchise data={sectionData.premium} isLoading={isLoading} />
      <Trending data={sectionData.trending} isLoading={isLoading} />
      <Internationaloprtunites data={sectionData.international} />
      {/* <TrendingVideo /> */}
      <Startup />
      {/* <Upcomingevents data={sectionData.upcoming} isLoading={isLoading} /> */}
      {/* <Newsblog /> */}
      <Featured data={sectionData.featured} isLoading={isLoading} />
      <Hometestimonials />
      <AboutFranchisebx />
      <Bussinesssection />
    </>
  );
}

export default Dashboard;
